import React from 'react';
import { RadioProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import CustomRadio, { ICustomRadioProps } from '.';

interface IProps extends Omit<ICustomRadioProps, 'handleChange' | 'selectedOption'> {
  name: string;
  customStyles?: any;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioController: React.FC<IProps> = ({
  name,
  options,
  label,
  customStyles,
  radioGroupProps,
  handleChange,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const foundedOption = options.find((option) => option.value === value);
        const currentValue = value && foundedOption ? value : options?.[0]?.value;
        return (
          <CustomRadio
            label={label}
            options={options}
            selectedOption={currentValue}
            radioGroupProps={radioGroupProps}
            customStyles={customStyles}
            handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              if (handleChange) {
                handleChange(e);
              } else {
                onChange(e.target.value);
              }
            }}
          />
        );
      }}
    />
  );
};

export default RadioController;
